import { createContext } from "react";
import type { AreaChartStore } from "../AreaChartProvider.types";

const AreaChartStoreContext = createContext<AreaChartStore<unknown> | undefined>(undefined);
AreaChartStoreContext.displayName = "AreaChartStoreContext";

export default AreaChartStoreContext;
